(() => {
  if (window.dutHeaderChatStarted) return;
  window.dutHeaderChatStarted = true;
  function findLauncher(root = document.querySelector('shopify-chat')?.shadowRoot) {
    if (!root) return null;
    const button = root.querySelector('button[part="activator"]');
    if (button) return button;
    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const nested = findLauncher(element.shadowRoot);
        if (nested) return nested;
      }
    }
    return null;
  }
  function bind(button) {
    if (button.dataset.connected) return;
    button.dataset.connected = 'true';
    button.addEventListener('click', event => {
      const drawer = button.closest('header-drawer');
      const drawerOpen = !!drawer?.querySelector('details[open]');
      if (drawerOpen) drawer.closeMenuDrawer(event);
      setTimeout(() => {
        if (document.getElementById('thunder-ai')?.dataset.ready === 'true') {
          document.dispatchEvent(new CustomEvent('dut-concierge-open'));
        } else {
          findLauncher()?.click();
        }
      }, drawerOpen ? 350 : 0);
    });
  }
  function connect() {
    const concierge = document.getElementById('thunder-ai');
    if (concierge?.dataset.ready === 'true') {
      document.querySelectorAll('.dut-header-chat, .dut-menu-chat').forEach(button => {
        button.hidden = false;
        button.setAttribute('aria-controls', 'tai-dialog');
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-expanded', String(!!concierge.querySelector('dialog')?.open));
        bind(button);
      });
      const oldChat = document.querySelector('shopify-chat');
      if (oldChat) { oldChat.hidden = true; oldChat.style.setProperty('display', 'none', 'important'); }
      document.documentElement.classList.add('dut-header-chat-ready');
      return true;
    }
    const launcher = findLauncher();
    const buttons = document.querySelectorAll('.dut-header-chat, .dut-menu-chat');
    if (!launcher || !buttons.length) return;
    const root = launcher.getRootNode();
    buttons.forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-expanded', launcher.getAttribute('aria-expanded') || 'false');
      bind(button);
    });
    const headerOpener = document.querySelector('.deh-utility__chat');
    const replacementReady = headerOpener?.dataset.connected === 'true' && !headerOpener.hidden && getComputedStyle(headerOpener).display !== 'none';
    let launcherStyle = root.querySelector('#dut-desktop-launcher-style');
    if (replacementReady) {
      if (!launcherStyle) {
        launcherStyle = document.createElement('style');
        launcherStyle.id = 'dut-desktop-launcher-style';
        root.appendChild(launcherStyle);
      }
      // Keep the conversation panel untouched; the connected header is its visible opener.
      const hiddenLauncher = 'button.activator{display:none!important}.activator-nudge{display:none!important}';
      if (launcherStyle.textContent !== hiddenLauncher) launcherStyle.textContent = hiddenLauncher;
    } else {
      launcherStyle?.remove();
    }
    const chat = document.querySelector('shopify-chat');
    // Keep the host concealed through startup/runtime replacement, but allow the conversation.
    chat?.toggleAttribute('data-dut-chat-visible', !replacementReady || launcher.getAttribute('aria-expanded') === 'true');
    document.documentElement.classList.toggle('dut-header-chat-ready', replacementReady);
    if (!launcher.dataset.dutObserved) {
      launcher.dataset.dutObserved = 'true';
      new MutationObserver(connect).observe(launcher, {attributes: true, attributeFilter: ['aria-expanded']});
    }
    return true;
  }
  // Inbox upgrades its initial launcher to a nested runtime after loading.
  // Reconnect when that runtime replaces the launcher or its shadow root.
  connect();
  document.addEventListener('dut-concierge-ready', connect);
  document.addEventListener('dut-concierge-state', connect);
  setInterval(connect, 500);
  document.addEventListener('shopify:section:load', connect);
})();
